import {
  brickRedDark1,
  brickRedDark2,
  brickRedLight1,
  dynamicOrangeLight1,
  dynamicOrangeLight2,
  electricYellow,
  electricYellowDark1,
  havelViolet,
  havelVioletDark1,
  havelVioletLight1,
  markishGreen,
  markishGreenDark1,
  spreeBlueLight1,
  spreeBlueLight2,
} from './bewColorPalette';

/// COLORS ///

// General colors
export const primaryColor = havelViolet;
export const appBackgroundColor = havelVioletLight1;
export const selectedColor = spreeBlueLight1;
export const successColor = markishGreenDark1;
export const warningColor = dynamicOrangeLight2;
export const dangerColor = brickRedDark1;

// Text
export const primaryFontColor = 'black';
export const placeholderFontColor = '#6c757d';
export const inactiveFontColor = '#767676';

// Tables
export const tableRowHighlightColor = selectedColor;
export const tableRowSecondaryHighlightColor = spreeBlueLight2;
export const tableRowDangerHighlightColor = brickRedLight1;
export const tableRowInactiveHighlightColor = '#aaa';

// Buttons
export const primaryButtonColor = electricYellow;
export const primaryButtonColorHover = electricYellowDark1;

export const secondaryButtonColor = primaryColor;
export const secondaryButtonColorHover = havelVioletDark1;

export const tertiaryButtonColor = primaryColor;

export const quaternaryButtonColor = electricYellow;

// Tabs
export const tabListBorderBottomColor = '#b7b7b7';
export const inactiveTabTextColor = inactiveFontColor;
export const tabBorder = '#999999';
export const activeTabTextColor = havelViolet;

// Borders
export const borderColor = '#b7b7b7';

// Status colors
export const uploadsOverviewAcceptedColor = markishGreen;
export const uploadsOverviewAcceptedWithRemarksColor = dynamicOrangeLight1;
export const uploadsOverviewRejectedColor = brickRedDark2;

// Form controls
export const formControlInput = '#495057';
export const formControlDisabledColor = '#edf1f6';

export const linkColor = '#007bff';
